import _ from "underscore";
import $ from "jquery";
import render from "../../utilities/render";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';

const elementsMap = {
    companyName: '#companyName',
    taxId: '#taxId',
  };
  const businessInformationElementsMap = {
    fscbusinessunit:'.fsc-business-unit',
    customerbusinessunit:'customer-business-unit',
    contractstartandenddate:'.contract-start-and-end-date',
    contracttype:'.contract-type'
  };
  const additionalInformationElementsMap = {
    primaryurl:'.primary-url',
    hostsystem:"#host-system",
    requireforwardstockinglocations:'.require-forward-stocking-locations'
 
  };
  const affiliatedInformationElementsMap = {
    affMerchantName: '#aff-merchant-name',
    addMerchantBtn: '.add-merchant-btn',
    addAffMerchant: '.add-aff-merchant',
    duplicateMessage: '#duplicate-message',
  };
export default function DetailsTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const fscbusinessunits = wizardElement.data('fscbusinessunits');
  const contracttype = wizardElement.data('contracttype');
  const els = {};

  const detailsTab = wizardElement.find('.details-tab');
  self.init = function(){
    renderDetailsTab();
  };

  function renderDetailsTab(){
    setElements();
    setUniqNamesAndIds(els);
    loadDropDowns();
   els.addMerchantBtn.on('click', function(e){
     e.preventDefault();
     let affMerchantNameValue = els.affMerchantName.val().trim();
     let addedAffiliatedMerchantHtml = ` <div class="col-xs-12 aff-merchant-text q-marg-top-md">
             <input class="q-input q-stretch affMerchantNameValue" maxlength="50"
             type="text" id="${affMerchantNameValue}" value="${affMerchantNameValue}"/>
             </div>`;
     if(affMerchantNameValue && affMerchantNameValue.trim() != ''){
       let valuesExists = false;
       $.each($('.affMerchantNameValue'), function(ind, element){
         let existingVal = $(element).val();
         if(affMerchantNameValue.toString().toUpperCase() === existingVal.toString().toUpperCase()){
           valuesExists = true;
           els.duplicateMessage.show();
         }
       });
       if(!valuesExists){
         els.duplicateMessage.hide();
         els.addAffMerchant.append(addedAffiliatedMerchantHtml);
       }
     }
     els.affMerchantName.val('');
     $('#one-affiliated-message').hide();
   });
  }
  function setElements(){
    setElementsFromScope(els, elementsMap, detailsTab);
    setElementsFromScope(els, businessInformationElementsMap, detailsTab);
    setElementsFromScope(els, additionalInformationElementsMap, detailsTab);
    setElementsFromScope(els, affiliatedInformationElementsMap, detailsTab);
  }
  function loadDropDowns() {
    $(fscbusinessunits).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      els.fscbusinessunit.append(option);
    });
    $(contracttype).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      els.contracttype.append(option);
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/DetailsTab.js